/* sanitize.css forms.css leaves form controls transparent; keep them on white. */
.brainConv input,
.brainConv select,
.brainConv textarea {
    background-color: #ffffff;
    color: #000000;
}
